import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'
import type { ComplaintsCategoriesQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  category: ComplaintsCategoriesQuery['complaints']['categoriesConnection']['nodes'][0] | null
  open: boolean
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}

export const DeleteCategoryModal = ({
  category,
  open,
  onClose,
  onConfirm,
  loading = false,
}: Props) => {
  if (!category) return null

  return (
    <F0Dialog
      isOpen={open}
      onClose={onClose}
      title={i18n.t('app_store_v2.apps.complaints.settings.categories.delete_modal.title')}
      primaryAction={{
        label: loading
          ? i18n.t('app_store_v2.apps.complaints.settings.categories.delete_modal.deleting')
          : i18n.t('app_store_v2.apps.complaints.settings.categories.delete_modal.delete'),
        onClick: onConfirm,
        disabled: loading,
        loading: loading,
      }}
      secondaryAction={{
        label: i18n.t('app_store_v2.apps.complaints.settings.categories.delete_modal.cancel'),
        onClick: onClose,
        disabled: loading,
      }}
    >
      <Box gap="s12">
        <Text.Normal>
          {i18n.t('app_store_v2.apps.complaints.settings.categories.delete_modal.message', {
            categoryName: category.name,
          })}
        </Text.Normal>
      </Box>
    </F0Dialog>
  )
}
